import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import NavBar from '../components/NavBar';

export default class Layout extends React.Component {
  render() {
    return (
      <Box
        sx={(theme) => ({
          backgroundColor: theme.custom?.background1,
          minHeight: '100vh',
        })}
      >
        <NavBar />
        <Box sx={(theme) => ({ backgroundColor: theme.custom?.background1 })}>
          <Outlet />
        </Box>
        {/* <Helper /> */}
      </Box>
    );
  }
}
